<template>
  <div id="app">
    <router-view v-if="isShow" />

    <!-- 全局悬浮 AI 助手 -->
    <div
      v-if="showAiIcon"
      ref="aiEntry"
      class="ai-chat-entry"
      :class="{ dragging: isDragging }"
      @mousedown="startDrag"
      @touchstart="startDrag"
      @click="handleClick"
      title="点击打开 AI 智能助手"
    >
      <!-- 完整的 SVG 图标 -->
      <svg viewBox="0 0 1024 1024" fill="currentColor" aria-hidden="true">
        <!-- 左侧聊天气泡 -->
        <path d="M384 160c-158.8 0-288 108.7-288 243 0 69.8 35.2 132.9 91.5 177.2l-27.2 117.9c-4.5 19.5 16.4 34.8 33.6 24.6l132.2-78.1c18.6 3.7 37.9 5.6 57.9 5.6 158.8 0 288-108.7 288-243S542.8 160 384 160z" fill="#ffffff"/>
        <!-- 右侧聊天气泡 -->
        <path d="M686 256c132.5 0 240 91.6 240 204.5 0 57.6-28 109.6-73.1 146.7l22.7 98.4c4.1 17.7-14.8 31.6-30.4 22.4l-109.3-64.6c-16 3.1-32.7 4.6-49.9 4.6-132.5 0-240-91.6-240-204.5S553.5 256 686 256z" fill="#ffffff" opacity="0.45"/>
        <!-- 对话线条 -->
        <rect x="250" y="330" width="270" height="44" rx="22" fill="#8c5aff"/>
        <rect x="250" y="420" width="220" height="44" rx="22" fill="#8c5aff"/>
        <rect x="250" y="510" width="150" height="44" rx="22" fill="#8c5aff"/>
      </svg>

      <!-- 已固定提示 -->
      <transition name="fade">
        <span v-show="showFixedTip" class="fixed-tip">已固定</span>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  provide () {
    return { reload: this.reload }
  },
  data () {
    return {
      isShow: true,
      isDragging: false,
      dragStart: { x: 0, y: 0 },
      offset: { x: 0, y: 0 },
      showFixedTip: false,
      showAiIcon: false,
      clickTimeout: null, // 用于区分点击和拖拽
      touchStartTime: 0, // 触摸开始时间
      touchStartPos: { x: 0, y: 0 }, // 触摸开始位置
      aiImage: require('@/assets/AI.png'),
      dragMoved: false,       // 是否发生过实质性移动
      shouldPreventClick: false, // 桌面端：本次操作是否应阻止 click
    }
  },
  created () {
    this.checkLoginStatus()
  },
  mounted () {
    this.loadPosition()
  },
  methods: {
    checkLoginStatus () {
      // 根据你的实际登录状态判断
      const token = this.$store.state.print?.goodsForeNo?.token
      this.showAiIcon = !!token
    },
    
    openAiBtms () {
      const token = this.$store.state.print?.goodsForeNo?.token || ''
      window.open(`https://ai-btms.sdbina.com/?token=${token}`, '_blank')
    },

    startDrag(e) {
  // 阻止默认事件（避免移动端页面滚动）
  e.preventDefault();

  // 记录起始信息
  const clientX = e.touches ? e.touches[0].clientX : e.clientX;
  const clientY = e.touches ? e.touches[0].clientY : e.clientY;
  this.touchStartTime = Date.now();
  this.touchStartPos = { x: clientX, y: clientY };

  // 重置拖拽相关标志
  this.dragMoved = false;
  this.shouldPreventClick = false;
  this.isDragging = true;  // 标记“按下”状态，不影响判断

  // 记录图标初始位置
  const rect = this.$refs.aiEntry.getBoundingClientRect();
  this.dragStart.x = clientX;
  this.dragStart.y = clientY;
  this.offset.x = rect.left;
  this.offset.y = rect.top;

  // 监听移动和结束
  document.addEventListener('mousemove', this.onDrag);
  document.addEventListener('touchmove', this.onDrag, { passive: false });
  document.addEventListener('mouseup', this.stopDrag);
  document.addEventListener('touchend', this.stopDrag);
},

    onDrag(e) {
  if (!this.isDragging) return;

  const clientX = e.touches ? e.touches[0].clientX : e.clientX;
  const clientY = e.touches ? e.touches[0].clientY : e.clientY;

  // 判断是否产生了有效移动（阈值 5px）
  if (!this.dragMoved) {
    const dx = clientX - this.touchStartPos.x;
    const dy = clientY - this.touchStartPos.y;
    if (Math.abs(dx) > 5 || Math.abs(dy) > 5) {
      this.dragMoved = true;           // 标记已发生拖拽
      this.shouldPreventClick = true;  // 桌面端将阻止后续 click
    } else {
      return; // 微小移动，不处理
    }
  }
   // 更新位置
   let x = this.offset.x + (clientX - this.dragStart.x);
  let y = this.offset.y + (clientY - this.dragStart.y);
  const maxX = window.innerWidth - 64;
  const maxY = window.innerHeight - 64;
  x = Math.max(0, Math.min(x, maxX));
  y = Math.max(0, Math.min(y, maxY));

  const el = this.$refs.aiEntry;
  el.style.left = x + 'px';
  el.style.top = y + 'px';
  el.style.right = 'auto';
  el.style.bottom = 'auto';
},
stopDrag(e) {
  // 移除所有监听
  document.removeEventListener('mousemove', this.onDrag);
  document.removeEventListener('touchmove', this.onDrag);
  document.removeEventListener('mouseup', this.stopDrag);
  document.removeEventListener('touchend', this.stopDrag);

  // 如果是触摸结束事件
  if (e.type === 'touchend') {
    if (!this.dragMoved) {
      // 没有实质性移动 → 判断是否为“轻点”
      const duration = Date.now() - this.touchStartTime;
      const touch = e.changedTouches[0];
      const dx = touch.clientX - this.touchStartPos.x;
      const dy = touch.clientY - this.touchStartPos.y;
      const distance = Math.sqrt(dx * dx + dy * dy);

      // 短时间、小距离 → 触发打开
      if (duration < 300 && distance < 10) {
        this.openAiBtms();
      }
      // 注意：即使是长时间按住但未移动，也忽略，不执行吸附
    } else {
      // 发生了拖拽 → 仅吸附固定
      this.snapToEdge();
      this.savePosition();
    }
  }
  // 如果是鼠标结束事件 (mouseup)
  else if (e.type === 'mouseup') {
    if (this.dragMoved) {
      // 拖拽了 → 吸附并保存
      this.snapToEdge();
      this.savePosition();
    }
    // 没有移动的情况不处理，留给 @click 打开
  }

  // 重置拖拽中状态
  this.isDragging = false;
},

    // 桌面端 click 处理（mousedown → mouseup → click）
handleClick(e) {
  if (this.shouldPreventClick) {
    // 发生过拖拽，阻止打开
    this.shouldPreventClick = false; // 重置，避免影响下一次
    e.preventDefault();
    e.stopPropagation();
    return;
  }
  // 正常的单击 → 打开
  this.openAiBtms();
},

   

    snapToEdge () {
      const el = this.$refs.aiEntry
      const rect = el.getBoundingClientRect()
      const centerX = rect.left + rect.width / 2
      const screenCenter = window.innerWidth / 2

      let x = rect.left
      if (centerX < screenCenter) {
        x = 12
      } else {
        x = window.innerWidth - rect.width - 12
      }

      el.style.transition = 'left 0.25s ease'
      el.style.left = x + 'px'

      this.showFixedTip = true
      setTimeout(() => {
        this.showFixedTip = false
        el.style.transition = 'none'
      }, 1200)
    },

    savePosition () {
      const el = this.$refs.aiEntry
      localStorage.setItem(
        'ai_icon_pos',
        JSON.stringify({ x: el.offsetLeft, y: el.offsetTop })
      )
    },

    loadPosition () {
      const pos = JSON.parse(localStorage.getItem('ai_icon_pos'))
      const el = this.$refs.aiEntry
      if (pos && el) {
        el.style.left = pos.x + 'px'
        el.style.top = pos.y + 'px'
        el.style.right = 'auto'
        el.style.bottom = 'auto'
      }
    },

    reload () {
      this.isShow = false
      this.$nextTick(() => {
        this.isShow = true
      })
    }
  }
}
</script>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}
html, body {
  width: 100%;
  overflow-x: hidden;
}

.ai-chat-entry {
  position: fixed;
  right: 24px;
  bottom: 24px;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: linear-gradient(135deg, #8c5aff, #6a4eff);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: grab;
  z-index: 9999;
  user-select: none;
  box-shadow: 0 8px 24px rgba(106, 78, 255, 0.38);
  transition: transform 0.2s ease;

  &.dragging {
    cursor: grabbing;
    transform: scale(1.08);
  }

  &:hover {
    transform: translateY(-3px) scale(1.05);
    box-shadow: 0 12px 30px rgba(106, 78, 255, 0.5);
  }

  svg {
    width: 36px;
    height: 36px;
    color: #ffffff;
  }

  .fixed-tip {
    position: absolute;
    top: -28px;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(0, 0, 0, 0.75);
    color: #fff;
    font-size: 12px;
    padding: 4px 10px;
    border-radius: 4px;
    white-space: nowrap;
    pointer-events: none;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(6px);
}
</style>